import ToastTitle from "../../atoms/toast/ToastTitle";
import ToastDescription from "../../atoms/toast/ToastDescription";
import ToastCloseButton from "./ToastCloseButton";

const ToastContent = ({ type, message }) => {
  return (
    <div
      className={`border-l-4 ${
        type === "success" ? "border-green-500" : "border-red-500"
      }`}
    >
      <div className="ml-5">
        <ToastTitle type={type} />
        <ToastDescription message={message} />
        <ToastCloseButton />
      </div>
    </div>
  );
};

export default ToastContent;
